import { useCallback } from "react"
import { CustomMutationParams, useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { chUndoDuplicatePatientsMutation } from "@/modules/patients/manage-duplicates/services/ch/chUndoDuplicatePatientsMutation"
import { deUndoDuplicatePatientsMutation } from "@/modules/patients/manage-duplicates/services/de/deUndoDuplicatePatientsMutation"
import { Country } from "@/types/__generated__/union-types"

type UndoDuplicatePatientsInput = {
  primaryPatientId: string
}

const useUndoDuplicatePatientsMutation = (country: Country, params?: CustomMutationParams) => {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chUndoDuplicatePatientsMutation
      case "DE":
        return deUndoDuplicatePatientsMutation
    }
  })()

  const [commit, isInFlight] = useMutationWithErrorToast(mutation, params)

  const commitHandler = useCallback(
    (input: UndoDuplicatePatientsInput, onCompleted?: () => void) => {
      commit({
        variables: {
          input,
        },
        onCompleted,
      })
    },
    [commit],
  )

  return [commitHandler, isInFlight] as const
}

export { useUndoDuplicatePatientsMutation }
